module.exports = __webpack_public_path__ + "img/reimu hakurei lunar war shaman.6d017f9b.png";